import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FaqListingComponent } from './view-all-faq/faq-listing.component';
// import { FaqSectionComponent } from './faq-list/faq-section.component';

const faqRoutes: Routes =
  [
    // {
    //   path: 'faq',
    //   component: FaqSectionComponent
    // },

    // {
    //   path: 'journal/:journal_id/faq',
    //   component: FaqListingComponent
    // },
    {
      path: 'journal/:journal_id/faq',
      component: FaqListingComponent,
      
    },

  ]



@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(faqRoutes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class FaqRoutingModule { }
